import { ServiceApi } from "./Api";

export class LoginService {

  autenticar(loginDTO) {
    return ServiceApi.post(`Api/Login/PostLogin/?name=${loginDTO.name}&cnonce=${loginDTO.cnonce}&md5=${loginDTO.md5}&sistema=webviewer`);
  }

  lembrarSenha(usuario) {
    return ServiceApi.post(`Api/Login/PostLembrarSenha/?tipo=medico&usuario=${usuario}&sistema=webviewer`);
  }

}
